import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Params } from "@angular/router";
import { getBottomRoute } from "@modules/+new/shared/universal-modal/functions/getRoute.fn";
import { merge, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class LastActivatedRoute {
	public getLast$ = (route: ActivatedRoute = this.route): Observable<ActivatedRoute> =>
		merge(route.url, route.data, route.queryParams, route.queryParams).pipe(
			// todo: add distinct to limit events emit
			map(() => getBottomRoute(this.route))
		);

	constructor(private route: ActivatedRoute) {}

	public get lastRoute(): ActivatedRoute {
		return getBottomRoute(this.route);
	}

	public getAllParams(startRoute: ActivatedRoute = this.lastRoute): Params {
		const root = startRoute.root;
		const flatRoutes = this.getFlatRoutes(root.snapshot);
		const paramsArr = flatRoutes.map((route) => route.params);

		return paramsArr.reduce((acc, item) => ({ ...acc, ...item }), {});
	}

	// TODO: eslint fix
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	private getFlatRoutes = (route: ActivatedRouteSnapshot): any => {
		const root = route.root;
		const { children } = root;
		const allDescendants = children.map((item) => this.getDescendants(item)).flat();

		return [root, ...children, ...allDescendants];
	};

	private getDescendants = (
		route: ActivatedRouteSnapshot,
		current: ActivatedRouteSnapshot[] = []
	): ActivatedRouteSnapshot[] => {
		const newCurrent = [...current, route];

		return route.firstChild ? this.getDescendants(route.firstChild, newCurrent) : newCurrent;
	};
}
